import { path, pathOr } from 'ramda';

import { type ICianApiSiteV1GetUserDataByRequestResponse } from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

import { type TUser } from '@/microfrontends/filters/shared/types/user';

export function prepareUser(response: ICianApiSiteV1GetUserDataByRequestResponse): TUser {
  const isAuthenticated = pathOr(false, ['user', 'isAuthenticated'], response.data);

  if (!isAuthenticated) {
    return { isAuthenticated };
  }

  return {
    isAuthenticated,
    // 'natural' | 'legal'
    accountType: path(['user', 'accountType'], response.data),
    // 'specialist' | 'agency'
    agentAccountType: path(['user', 'agentAccountType'], response.data),
    balance: pathOr(0, ['user', 'balance'], response.data),
    displayName: pathOr(null, ['user', 'displayName'], response.data),
    // string
    email: pathOr('', ['user', 'email'], response.data),
    firstName: pathOr('', ['user', 'firstName'], response.data),
    // number
    id: pathOr(0, ['user', 'id'], response.data),
    isAgent: pathOr(false, ['user', 'isAgent'], response.data),
    isBuilder: pathOr(false, ['user', 'isBuilder'], response.data),
    isModerator: pathOr(false, ['user', 'isModerator'], response.data),
    isNew: pathOr(false, ['user', 'isNew'], response.data),
    isProfi: pathOr(false, ['user', 'isProfi'], response.data),
    isSubscriptions: pathOr(false, ['user', 'isSubscriptions'], response.data),
    lastName: pathOr(null, ['user', 'lastName'], response.data),
    // IUserPermissions
    permissions: pathOr(null, ['user', 'permissions'], response.data),
    // IUserPhone[] | null
    phones: pathOr(null, ['user', 'phones'], response.data),
    // boolean?, в API string
    publicProfile: pathOr(false, ['user', 'publicProfile'], response.data),
    // string[]
    tariff: pathOr([], ['user', 'tariff'], response.data),
    // number
    userId: pathOr(0, ['user', 'userId'], response.data),
    // string
    userType: pathOr('', ['user', 'userType'], response.data),
  };
}
